import React, { useEffect, useState } from 'react';
import {
  Col,
  Row,
  VertCarousel,
  VertContainer,
  VertImage,
} from '@vertem-core/vertice-ds';
import SkeletonButton from 'antd/es/skeleton/Button';
import '@/Assets/styles/default/components/BannerSupplier/BannerSupplierStyle.less';
import { useSelector } from 'react-redux';
import { getFilteredTradeMenu } from '../ShowcaseImages/ShowcaseImages';
import { useNavigate } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';

const CarouselConfig = {
  dots: false,
  arrows: true,
  itemsPerPage: 1,
  variableWidth: false,
};
const BannerSupplier = () => {
  const Type = 'banner-supplier';
  const TypeMobile = 'banner-supplier-mobile';
  const TypeTablet = 'banner-supplier-tablet';
  const Navigate = useNavigate();
  const isTablet = useMediaQuery({ maxWidth: '768px' });
  const isMobile = useMediaQuery({ maxWidth: '576px' });
  const [loading, setLoading] = useState(true);
  const CmsStatic = useSelector(({ CmsStatic: data }) => data);
  const [items, setItems] = useState(null);
  const [itemsMobile, setItemsMobile] = useState(null);
  const [itemsTablet, setItemsTablet] = useState(null);

  useEffect(() => {
    if (CmsStatic?.requestMake && !CmsStatic?.isLoading) {
      const banners = getFilteredTradeMenu(CmsStatic, Type);
      const bannersTablet = getFilteredTradeMenu(CmsStatic, TypeTablet);
      const bannersMobile = getFilteredTradeMenu(CmsStatic, TypeMobile);

      setLoading(false);
      setItems(banners);
      setItemsTablet(bannersTablet);
      setItemsMobile(bannersMobile);
    }
  }, [CmsStatic?.requestMake]);

  const handleSizeRenderItemsBanner = () => {
    if (isMobile && itemsMobile && itemsMobile.length) {
      return itemsMobile;
    } else if (isTablet && itemsTablet && itemsTablet.length) {
      return itemsTablet;
    }
    return items;
  };

  if (items && !items.length) return null;
  if (items && items.length === 1) {
    CarouselConfig.arrows = false;
  } else if (items) {
    CarouselConfig.arrows = true;
  }
  return (
    <VertContainer>
      <section
        className={`padding-x-regular ${
          isMobile ? 'padding-y-small' : 'padding-y-big margin-bottom-big'
        }`}
      >
        {(() => {
          if (!loading && items)
            return (
              <>
                <VertCarousel {...CarouselConfig}>
                  {(() => {
                    return handleSizeRenderItemsBanner().map(
                      ({ icon, path }) => (
                        <div>
                          <Row>
                            <Col span={24}>
                              <Row
                                align="middle"
                                justify={'center'}
                                className={`BannerSupplierItem ${
                                  !isMobile ? 'padding-x-small' : ''
                                }`}
                              >
                                <Row
                                  className="margin-x-none BannerSupplierItem-canvas"
                                  align="middle"
                                  justify={'center'}
                                >
                                  <VertImage
                                    onClick={() => Navigate(path)}
                                    key={icon}
                                    src={icon}
                                  />
                                </Row>
                              </Row>
                            </Col>
                          </Row>
                        </div>
                      )
                    );
                  })()}
                </VertCarousel>
              </>
            );
          return (
            <Row>
              <SkeletonButton
                active
                shape="round"
                rootClassName="col padding-x-extra-small BannerSupplierItem-loading"
              />
            </Row>
          );
        })()}
      </section>
    </VertContainer>
  );
};

export default BannerSupplier;
